import { Injectable } from '@angular/core';
import { isNil, reject } from 'lodash-es';

import { UserModulePushOutput } from 'infrastructure/graphql/messaging/user/model/user-module-push.output';
import { UserModulePushStatus } from 'user/model/module/push/user-module-push-status';
import { UserModulePush } from 'user/user-module-push';

@Injectable({ providedIn: 'root' })
export class UserModulePushConverterService {
	public userModulePushAsEntity(output: UserModulePushOutput): UserModulePush {
		if (!output) {
			return null;
		}

		return new UserModulePush(
			output.emailId,
			output.contactId,
			output.contactName,
			output.contactLanguage,
			output.pushOrgModuleId,
			output.contactEmailAddress,
			UserModulePushStatus[output.status]
		);
	}

	public userModulePushesAsEntities(
		outputs: UserModulePushOutput[]
	): UserModulePush[] {
		return reject(outputs, isNil).map((output) =>
			this.userModulePushAsEntity(output)
		);
	}
}
